module.exports = __webpack_public_path__ + "img/1.8b805b00.svg";